import React, { Component } from "react";
import Table from "./common/table";
import Timer from "./common/timer";
import Download from "../Images/Download-32.png";
import Agreement from "../Images/Agreement-32.png";
import LinkButton from "./common/linkButton";
import DropDownAction from "./common/dropDownAction";
import "./Form/proposalForm.css";
import { getCurrentUser } from "aws-amplify/auth";

class ProposalTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      TimmerSeconds: 1,
      currentUser: "",
      progress: {},
    };
  }

  componentDidMount = async () => {
    let currentUser = await getCurrentUser().catch((e) => {
      // User not authenticated - this is expected
      return null;
    });
    if (currentUser) {
      this.setState({ currentUser: currentUser.username });
    }
  };

  bondObject = { path: "REGISTRATION", label: "Registration" };
  excelObject = {
    label: "Bond - Risk",
    key: "bond-risk",
    content: (proposal) => {
      const bond = proposal["BOND"] || "";
      const embeddedExcel = proposal["embedded-excel"];
      const riskTolerance = proposal["RISK TOLERANCE"];
      const risk = proposal["RISK"];

      // Priority fallback: embedded-excel > RISK TOLERANCE > RISK > blank
      let secondValue = "";
      if (embeddedExcel != null && embeddedExcel !== "") {
        secondValue = embeddedExcel;
      } else if (riskTolerance != null && riskTolerance !== "") {
        secondValue = riskTolerance;
      } else if (risk != null && risk !== "") {
        secondValue = risk;
      }

      return `${bond} ${secondValue}`.trim();
    },
  };
  incomeNeedsObject = { path: "INCOME", label: "Income Needs" };
  userNameObject = { path: "UserName", label: "User Name" };
  advisorName = { path: "ADVISOR NAME", label: "Advisor Name(s)" };
  columns = [
    {
      label: () => (
        <div style={{ height: "22px", width: "22px" }}>
          <input
            onChange={(e) => this.props.handleToggleSelectAll(e)}
            className="form-check-input"
            type="checkbox"
            name="checkbox"
            id="checkboxAll"
            checked={this.props.selectAll === 1 || ""}
            style={{
              margin: "0 0 0 0",
              height: "20px",
              width: "20px",
              position: "top -30px",
            }}
            disabled={this.props.deleteAllInProgress}
          />
        </div>
      ),
      key: "checkbox",
      content: (proposal) => (
        <div style={{ height: "22px", width: "22px" }}>
          <input
            disabled={this.props.deleteAllInProgress || !proposal["Download"]}
            onChange={(e) => this.props.handleToggleRow(proposal, e)}
            className="form-check-input"
            type="checkbox"
            name="checkbox"
            id={`checkbox_${
              proposal.FileName
                ? proposal.FileName.replace(".pdf", "")
                : `${proposal["CLIENT NAMES"]}_${proposal["DateTime"]}`
            }`}
            checked={
              this.props.selected[
                `${proposal["CLIENT NAMES"]}_${proposal["DateTime"]}`
              ] || ""
            }
            style={{ margin: "auto", height: "20px", width: "20px" }}
          />
        </div>
      ),
    },
    {
      path: "CLIENT NAMES",
      label: "Client Name(s)",
    },
    { path: "program", label: "Strategy" },
    { path: "VALUE", label: "Asset Value" },
    { path: "DateTime", label: "Date - Time" },
    {
      label: "Downloads",
      key: "downloads",
      content: (proposal) => (
        <div>
          <div className="row" style={{ margin: "auto" }}>
            <DropDownAction
              customStyle={{
                width: "100%",
                height: "35px",
                padding: "3px",
                backgroundColor: "#385EA4",
                color: "white",
                outline: "none",
                border: "none",
              }}
              style={{
                outline: "none",
                border: "none",
                margin: "auto",
                width: "100%",
                borderColor: "white",
              }}
              title={
                <div style={{ paddingBottom: "2px" }}>
                  {this.state.progress[
                    proposal["CLIENT NAMES"] + proposal["DateTime"]
                  ] ? (
                    <div
                      style={{ display: "inline-block", marginRight: "5px" }}
                    >
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </div>
                  ) : null}
                  Proposal{" "}
                  <span style={{ margin: "auto", fontSize: "10px" }}>
                    &#9660;
                  </span>
                </div>
              }
              ulStyle={{
                padding: "0",
              }}
              drop="dropdown"
              items={[
                <button
                  title={
                    proposal["Download"] !== "true"
                      ? proposal["Download"] === "false"
                        ? "download failed"
                        : "Download May Not Be Ready"
                      : "Download"
                  }
                  style={{
                    margin: "auto",
                    marginRight: "10px",
                    padding: "4px 2px",
                    backgroundColor: "#385EA4",
                    color: "white",
                    borderColor: "white",
                  }}
                  disabled={!proposal["Download"] ? true : false}
                  onClick={() => {
                    if (proposal["Download"] === "false") {
                      alert(
                        `Try refreshing the page or waiting 10 minutes to try again. An alert has alredy been sent to us.`
                      );
                    } else {
                      if (
                        new Date(String(proposal["DateTime"])).getTime() <
                        new Date().getTime() - 30 * 24 * 60 * 60 * 1000
                      ) {
                        alert(
                          "This proposal is more than 30 days old. We recommend you run a new one to get the most up to date information."
                        );
                      }
                      const onClickThis = this;
                      this.addProgress(proposal);
                      this.props.onDownload(proposal, function (x) {
                        const id =
                          proposal["CLIENT NAMES"] + proposal["DateTime"];
                        onClickThis.setState((previousState) => {
                          return {
                            progress: { ...previousState.progress, [id]: x },
                          };
                        });
                        if (x >= 100) {
                          onClickThis.removeProgress(proposal);
                        }
                      });
                    }
                  }}
                  className="col btn"
                >
                  {proposal["Download"] && proposal["Download"] !== "false" ? (
                    this.state.progress[
                      proposal["CLIENT NAMES"] + proposal["DateTime"]
                    ] ? (
                      <React.Fragment>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span style={{ marginLeft: "10px" }}>Downloading</span>
                      </React.Fragment>
                    ) : (
                      <span>
                        <img
                          src={Download}
                          alt="Download"
                          style={{ height: "20px" }}
                        />
                        Download
                      </span>
                    )
                  ) : proposal["Download"] !== "false" ? (
                    <label style={{ margin: "0", minWidth: "20px" }}>
                      {
                        <Timer
                          getTimmerProgress={(s) =>
                            this.setState({ TimmerSeconds: s })
                          }
                          seconds={(() => {
                            const isFusion =
                              proposal.program &&
                              proposal.program
                                .toString()
                                .toLowerCase()
                                .includes("fusion");
                            const eta = isFusion ? 90 : 30;
                            if (proposal["DateTime"]) {
                              const proposalTime = new Date(
                                String(proposal["DateTime"])
                              );
                              const now = new Date();
                              const diffSeconds = Math.abs(
                                (proposalTime - now) / 1000
                              );
                              // If proposal is less than ETA seconds old, show remaining ETA
                              if (diffSeconds < eta) {
                                return Math.round(eta - diffSeconds);
                              }
                              // Otherwise, just show ETA
                              return eta;
                            }
                            return eta;
                          })()}
                        />
                      }
                      {this.state.TimmerSeconds > 0 ? (
                        <span style={{ marginLeft: "4px" }}>
                          (Download ETA)
                        </span>
                      ) : (
                        <span>Click Refresh Above</span>
                      )}
                    </label>
                  ) : (
                    <label style={{ margin: "0", minWidth: "20px" }}>
                      Failed. Try again in 10-15 minutes.
                    </label>
                  )}
                </button>,
                <LinkButton
                  to={{
                    pathname: "/paperwork",
                    state: {
                      proposal: proposal,
                    },
                  }}
                  title="Paperwork"
                  disabled={
                    proposal["papercheck"] ? !proposal["papercheck"] : true
                  }
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "#368fff",
                    color: "white",
                    borderColor: "white",
                  }}
                  onClick={() => null}
                  className="col btn btn-sm"
                >
                  <span>
                    <img
                      src={Agreement}
                      alt="Paperwork"
                      style={{ height: "20px" }}
                    />{" "}
                    Paperwork
                  </span>
                </LinkButton>,
              ]}
            />
          </div>
        </div>
      ),
    },
  ];
  filterColumns = [];
  timer = 0;
  state = { time: {}, progress: {} };

  addProgress = (proposal) => {
    const id = proposal["CLIENT NAMES"] + proposal["DateTime"];
    this.setState((previousState) => {
      return {
        progress: { ...previousState.progress, [id]: 1 },
      };
    });
  };

  removeProgress = (proposal) => {
    const id = proposal["CLIENT NAMES"] + proposal["DateTime"];
    let currentProgressState = this.state.progress;
    delete currentProgressState[id];
    this.setState({ progress: currentProgressState });
  };

  render() {
    const { proposals, onSort, sortColumn } = this.props;
    if (
      this.props.showDetails &&
      !this.columns.includes(this.bondObject) &&
      !this.columns.includes(this.excelObject)
    ) {
      this.columns.splice(1, 0, this.userNameObject);
      this.columns.splice(2, 0, this.advisorName);
      this.columns.splice(3, 0, this.bondObject);
      this.columns.splice(4, 0, this.excelObject);
    } else if (
      !this.props.showDetails &&
      this.columns.includes(this.bondObject) &&
      this.columns.includes(this.excelObject)
    ) {
      this.columns.splice(this.columns.indexOf(this.userNameObject), 1);
      this.columns.splice(this.columns.indexOf(this.advisorName), 1);
      this.columns.splice(this.columns.indexOf(this.bondObject), 1);
      this.columns.splice(this.columns.indexOf(this.excelObject), 1);
    }

    return (
      <div>
        <Table
          updateColumnList={this.props.updateColumnList}
          columns={this.columns}
          data={proposals}
          sortColumn={sortColumn}
          onSort={onSort}
        />
      </div>
    );
  }
}

export default ProposalTable;
